import {
	UploadAttachmentRequestDTO,
	UploadAttachmentResponseDTO,
	GetAttachmentsRequestDTO,
	GetAttachmentsResponseDTO,
	DestroyAttachmentRequestDTO
} from '@/core/dto/attachment';
import { BaseService } from './base-service';

export class AttachmentReportService extends BaseService<any> {
	private static instance: AttachmentReportService;

	private constructor(public readonly basePath: string = '/attachment') {
		super();
	}

	public static getInstance(): AttachmentReportService {
		if (!AttachmentReportService.instance) {
			AttachmentReportService.instance = new AttachmentReportService();
		}
		return AttachmentReportService.instance;
	}

	async create(params: any): Promise<any> {
		const url = this.basePath + '/';
		const { data } = await this.getInstance().post<any>(url, params);
		return data;
	}

	async update(params: any): Promise<any> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().put<any>(url, params);
		return data;
	}

	public async uploadAttachment(params: UploadAttachmentRequestDTO): Promise<UploadAttachmentResponseDTO> {
		const url = this.basePath + '/upload';
		const { data } = await this.getInstance().post<UploadAttachmentResponseDTO>(url, params);
		return data;
	}

	public async getAttachments(params: GetAttachmentsRequestDTO): Promise<GetAttachmentsResponseDTO> {
		const url = this.basePath;
		const { data } = await this.getInstance().get<GetAttachmentsResponseDTO>(url, { params });
		return data;
	}

	public async destroyAttachment(params: DestroyAttachmentRequestDTO): Promise<void> {
		const { id, ...payload } = params;
		const url = this.basePath + `/${id}`;
		await this.getInstance().delete(url, {
			params: payload
		});
	}
}
